import { Component } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { PicajesPage } from '../../pages/picajes/picajes';

import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ListPage } from '../list/list';

/**
 * Generated class for the empresasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-empresas',
  templateUrl: 'empresas.html',
})
export class EmpresasPage {

  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  myForm2: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {codigo1: "",nombre1: "",cif1: ""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  empresas;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  empresasKeys;
  values:Array<string> = [];
  emailCuenta = '';
  guardandoEmail = false;



  
  constructor(
  	public navParams: NavParams,
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variables:VariablesProvider
    ) {                    
            
            this.variables.btatras = true;
            var sum = 0;
            var horas=0;
            
          
  
      this.myForm = this.fb.group({

      id: [''],
      nombre: ['' ],
      cif: ['' ]
      
     });

 this.myForm1 = this.fb.group({

      id1: ['', [Validators.required]],
      nombre1: ['', [Validators.required]],
      cif1: ['']
    
     });
   

    this.obtenerempresas(this.valo);
    this.cargarEmailCuenta();

  }

  cargarEmailCuenta() {
    const usuario = this.variables.CLIENTES_RAZSOCIAL || this.variables.emailoriginal;
    if (!usuario) { return; }
    this.funciones.obtieneUserEmail(usuario).then((data: any) => {
      const fila: any = Array.isArray(data) ? (data[0] || {}) : (data || {});
      this.emailCuenta = fila.EMAIL || fila.email || '';
    });
  }

  guardarEmailCuenta() {
    if (this.guardandoEmail) { return; }
    const email = (this.emailCuenta || '').trim();
    if (email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.alertCtrl.create({ title: 'Correo no válido', message: 'Introduce un correo válido o déjalo vacío.', buttons: ['Aceptar'] }).present();
      return;
    }
    const usuario = this.variables.CLIENTES_RAZSOCIAL || this.variables.emailoriginal;
    this.guardandoEmail = true;
    this.funciones.actualizaUserEmail(usuario, email).then((data: any) => {
      const fila: any = Array.isArray(data) ? (data[0] || {}) : (data || {});
      if (String(fila.RESULTADO || '').toUpperCase() !== 'OK') {
        throw new Error(fila.MENSAJE || 'No se pudo guardar el correo');
      }
      this.variables.emailactivo = email;
      this.alertCtrl.create({ title: 'Correo guardado', message: 'Este correo se utilizará también para los resúmenes.', buttons: ['Aceptar'] }).present();
    }).catch(error => {
      console.log(error);
      this.alertCtrl.create({ title: 'Error', message: 'No se pudo guardar el correo.', buttons: ['Aceptar'] }).present();
    }).then(() => { this.guardandoEmail = false; });
  }

   buscarempresas(){
     var neutro;
    if (this.formulario2.valor != ""){
      neutro = this.formulario2.valor;
     }else{
      neutro = this.valo;
    }
    //console.log("Vamos a buscar :" + neutro);
    this.funciones.obtieneempresas(neutro).then(
          data => {

          this.empresas = data;

          //console.log(this.empresas);

          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

  obtenerempresas(filtro){

    this.funciones.obtieneempresas(filtro).then(
          data => {

          this.empresas = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

   editarempresas(index){

     //console.log(this.empresas[index].ID);
     //console.log(this.empresas[index].NOMBRE);
    
    this.funciones.editarempresas(this.empresas[index].ID,this.empresas[index].NOMBRE,this.empresas[index].CIF).then(
          data => {
            //console.log(data);
            this.empresas = data;
            this.obtenerempresas(this.valo);
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
     
  }

  
  salir(){
    this.navCtrl.push(ListPage);
 }

  registro(){

   if (this.formulario.cif1==""){this.formulario.cif1='123456'}

   this.funciones.grabarempresas(this.formulario.nombre1,this.formulario.cif1).then(
     data => {
          this.resultado = data;
          //console.log(data);

          this.obtenerempresas(this.valo);

           this.formulario.nombre1="";
           this.formulario.cif1="";

           
        })


  }

   borrar(codigo,nombre){

   

      let alert = this.alertCtrl.create({
          title: 'Borrar.',
          message: '¿Confirma borrar la Empresa? '  + codigo + ' -> ' + nombre,
          cssClass: 'alertCustomCss',
          buttons: [{
              text: 'No',
              role: 'No',
              handler: () => {  }
            },{
              text: 'Si',
              handler: () => {


               this.funciones.delempresas(codigo).then(
                   data => {
                    
                    this.obtenerempresas(this.valo);

                  })           
              }
            }
          ]
        });
        alert.present();
     
  }


 
 valChange(campo:string, value:string, index:number):void{
      
      //alert("Campo->" + campo + "valor->" + value + "lugar->" + index)

      switch (campo) {
         case "ID":
           this.empresas[index].ID = value;
           break;
         case "NOMBRE":
           this.empresas[index].NOMBRE = value;
           break;
        case "CIF":
            this.empresas[index].CIF = value;
            break;
        
         
         default:
           // code...
           break;
       }
     
    }


}



// WEBPACK FOOTER //
// ./src/pages/empresas/empresas.ts